import React from 'react'

function DealFlow() {
  return (
    <div>DealFlow</div>
  )
}

export default DealFlow